import { useContext } from "react";
import { OptimizelyContext } from "@optimizely/react-sdk";
import useFeatureFlag from "@hooks/useFeatureFlag";
import useDeviceInfo from "@hooks/useDeviceInfo";

const useOptimizely = () => {
  const { optimizely } = useContext(OptimizelyContext);
  const { enable_testing } = useFeatureFlag();
  const { cookieConsent } = useDeviceInfo();

  if (!cookieConsent) {
    return {
      track: () => {},
    };
  } else if (enable_testing) {
    return {
      track: (data, a, b, c) => {
        console.log(
          `%cTest flag enabled, skipping Optimizely event: ${data} ${a} ${JSON.stringify(
            b
          )} ${JSON.stringify(c)}`,
          "color: #fbd911"
        );
      },
    };
  }
  return optimizely;
};

export default useOptimizely;
